/**
 * Turn what a person typed into a permanent id.
 *
 * Used by every "create a catalogue row" dialog — packages, products — because
 * they all share the same hard problem: the id is the `_id`, Mongo will not
 * change it, other rows point at it, and there is no rename. Whatever this
 * function produces is permanent.
 *
 * Diacritics are FOLDED rather than stripped, because the people naming these
 * are Swedish and "Kanalpaket för hotell" must not become
 * `kanalpaket-f-r-hotell` — a permanent id that reads as a typo and cannot be
 * corrected. NFD splits `ö` into `o` plus a combining ring; the range below
 * drops the mark and keeps the letter.
 */
export function slugifyId(input: string): string {
  return input
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

/** The server's rule, mirrored so a refusal arrives before the round trip. */
export const CATALOGUE_ID_RE = /^[a-z0-9][a-z0-9-]*$/;
